import styled from 'styled-components'

const HideForPrint = styled.div`
  @media print {
    display: none;
  }
`

export { HideForPrint }
